<template>
  <div>
    <div v-if="fixture">
      <div class="box">
        <p class="title is-5">{{fixture.name}}</p>
        <p class="subtitle is-6">
          {{fixture.location}}
          <br>
          {{fixture.status_name || "Unknown Status"}}
          <br>
          {{fixture.starts_at}}
          <br>
          {{fixture.ss_id}}
          <span v-if="fixture.leaderboard">
            <br>
            {{fixture.leaderboard}}
            <a
              v-if="fixture.leaderboard.indexOf('NULL') != -1"
              href="javascript:void(0)"
              @click="updateLeaderboardId"
            >Set Leaderboard</a>
          </span>
        </p>
        <div class="tags">
          <span class="tag is-primary" :key="tag" v-for="tag in fixture.tags">{{tag}}</span>
        </div>
        <div>
          <a
            v-if="fixture.reimportable"
            href="javascript:void(0)"
            @click.prevent="reimport"
          >Reimport Fixture Details</a>
        </div>
        <hr v-if="fixture.home_team && fixture.away_team">
        <div class="columns" v-if="fixture.home_team && fixture.away_team">
          <div class="column centered">
            <img
              class="team-logo"
              :src="fixture.home_team.image_url"
              :alt="fixture.home_team.short_name"
            >
            <br>
            <span class="team-name">
              {{fixture.home_team.short_name || fixture.home_team.name}}
              {{ fixture.home_team.score || fixture.home_team.score == 0 ? `(${fixture.home_team.score})` : '' }}
            </span>
          </div>
          <div class="column centered">
            <img
              class="team-logo"
              :src="fixture.away_team.image_url"
              :alt="fixture.away_team.short_name"
            >
            <br>
            <span class="team-name">
              {{fixture.away_team.short_name || fixture.away_team.name}}
              {{ fixture.away_team.score || fixture.away_team.score == 0 ? `(${fixture.away_team.score})` : '' }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="editableFixture">
        <!-- RSA Channel -->
        <div class="field">
          <label class="label">
            <b-tooltip
              position="is-right"
              label="The channels of the fixture in South Africa"
              dashed
              type="is-dark"
            >South African Channel</b-tooltip>
          </label>
          <div class="control">
            <input class="input" type="text" v-model="editableFixture.channel_rsa">
          </div>
        </div>
        <!-- ROA Channel -->
        <div class="field">
          <label class="label">
            <b-tooltip
              position="is-right"
              label="The channels of the fixture for the rest of Africa"
              dashed
              type="is-dark"
            >African Channel</b-tooltip>
          </label>
          <div class="control">
            <input class="input" type="text" v-model="editableFixture.channel_africa">
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <!-- visible -->
            <div class="field">
              <label class="label">
                <b-tooltip
                  position="is-right"
                  label="If disabled the fixture will be hidden on all frontends"
                  dashed
                  type="is-dark"
                >Visible</b-tooltip>
              </label>
              <b-switch v-model="editableFixture.visible" type="is-success"></b-switch>
            </div>
          </div>
          <div class="column">
            <!-- visible -->
            <div class="field">
              <label class="label">
                <b-tooltip
                  position="is-right"
                  label="Used to override the live scoring status of the fixture. Useful when the feed is marked as non-live-scored but this particular fixture will be live scored."
                  dashed
                  multilined
                  type="is-dark"
                >Live Scored (Override)</b-tooltip>
              </label>
              <div v-if="typeof(editableFixture.scored_live) != typeof(true)">
                This fixture is currently not being overridden,
                <a
                  href="javascript:void(0)"
                  @click.prevent="enableOverride"
                >enable override</a>
              </div>
              <div v-else>
                <b-switch v-model="editableFixture.scored_live" type="is-success"></b-switch>
                <span class="is-size-7">
                  <br>
                  This is currently being overridden. Feed value is {{editableFixture.feed_scored_live}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- save button -->
        <div class="field">
          <button class="button is-primary" @click="updateFixture">Save Changes</button>
        </div>
        <loading v-if="loading"></loading>
      </div>
    </div>
    <loading v-else></loading>
  </div>
</template>

<script>
import {
  GET_FIXTURE,
  UPDATE_FIXTURE,
  REIMPORT_FIXTURE,
  UPDATE_FIXTURE_LEADERBOARD
} from "@/store/actions";
import { SET_FIXTURE } from "@/store/mutations";
import Loading from "@/components/Loading";

export default {
  name: "fixture",
  components: {
    Loading
  },
  data() {
    return {
      editableFixture: null,
      loading: false
    };
  },
  computed: {
    fixtureId() {
      return this.$route.params.fixture_id;
    },
    fixture() {
      return this.$store.state.fixture.item;
    }
  },
  mounted() {
    let { fixture, fixtureId } = this;
    if (!fixture || fixture.id !== fixtureId) {
      this.getFixture();
    }

    if (fixture) {
      this.editableFixture = { ...fixture };
    }
  },
  methods: {
    getFixture() {
      let { fixture, fixtureId } = this;

      this.$store.commit(SET_FIXTURE, null);
      this.$store.dispatch(GET_FIXTURE, fixtureId).then(res => {
        if (res.data) {
          this.editableFixture = { ...res.data };
        }
      });
    },
    updateFixture() {
      this.loading = true;
      this.$store
        .dispatch(UPDATE_FIXTURE, this.editableFixture)
        .then(res => {
          if (res.status === 204) {
            this.$success("Fixture Saved");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reimport() {
      this.loading = true;
      this.$store
        .dispatch(REIMPORT_FIXTURE, this.fixture.id)
        .then(res => {
          if (res.status === 204) {
            this.$success("Fixture Reimported");
            this.$store.dispatch(GET_FIXTURE, this.fixture.id).then(res => {
              if (res.data) {
                this.editableFixture = { ...res.data };
              }
            });
          }
        })
        .catch(err => {
          this.$error("Failed to reimport fixture");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    enableOverride() {
      this.editableFixture.scored_live = true;
    },
    updateLeaderboardId() {
      this.$dialog.prompt({
        message: `Enter new leaderboard ID`,
        inputAttrs: {
          value: ""
        },
        onConfirm: value =>
          this.$store
            .dispatch(UPDATE_FIXTURE_LEADERBOARD, {
              leaderboard_id: value,
              id: this.fixture.id
            })
            .then(res => {
              if (res && res.status === 204) {
                this.getFixture();
              }
            })
      });
    }
  }
};
</script>

<style scoped>
.team-logo {
  width: 48px;
  height: 48px;
}
.team-name {
  font-size: 13px;
}
.centered {
  text-align: center;
}
</style>